import { gql } from 'apollo-boost';

export const TICKET_CLAIM_FRAGMENT = gql`
  fragment TicketClaimFragment on TicketClaim {
    id
    attendee {
      city
      company
      country
      email
      firstName
      lastName
      phone
      salutation
      state
      street
      street2
      zip
    }
    ticketDefinition {
      id
      sortIndex
      name
      description
      price
    }
    promoCode {
      code
      discountFlat
      discountPercent
    }
    surveyResponses {
      questionId
      response
    }
  }
`;

export const MESSAGE_FRAGMENT = gql`
fragment MessageFragment on ClientMessage {
  type
  subject
  content
  ref
}`;

export const ORDER_FRAGMENT = gql`
  fragment OrderFragment on QueryPendingOrder {
    id
    donationAmount
    totalAmount
    expires
    method
    purchaser {
      salutation
      firstName
      lastName
      email
      phone
      address {
        street
        street2
        city
        state
        zip
        country
      }
    }
    promoCodes {
      id
      code
      discountFlat
      discountPercent
      ticketDefinition {
        id
        sortIndex
        name
        description
        price
      }
    }
    ticketDefinitions {
      id
      sortIndex
      name
      description
      price
      promoPrice
      remainingCount
      showRemainingQuantity
      survey {
        surveyId
        name
        questions {
          id
          choices
          isResponseRequired
          question
          questionType
        }
      }
    }
    claims {
      ...TicketClaimFragment
    }
  }
  ${TICKET_CLAIM_FRAGMENT}
`;

// ****************************************
// CREATE
// ****************************************

export const CONTACT_PROMOTER = gql`
  mutation ContacatPromoter($id: UUID!, $message: ContactPromoterMessage!) {
    contactPromoter(eventId: $id, message: $message) {
      errors
    }
  }
`;

export const BEGIN_ORDER = gql`
  mutation BeginOrder($id: UUID!, $draftOnly: Boolean) {
    beginOrder(eventId: $id, draftOnly: $draftOnly) {
      errors
      order {
        ...OrderFragment
      }
    }
  }
  ${ORDER_FRAGMENT}
`;

export const CLAIM_TICKETS = gql`
  mutation ClaimTickets($id: UUID!, $ticketDefinitionId: UUID!, $quantity: Int!) {
    order(id: $id) {
      claimTickets(
        quantity: $quantity
        ticketDefinitionId: $ticketDefinitionId
      ) {
        messages { ...MessageFragment }
        errors
        order {
          ...OrderFragment
        }
      }
    }
  }
  ${MESSAGE_FRAGMENT}
  ${ORDER_FRAGMENT}
`;

export const UPDATE_CLAIM = gql`
  mutation UpdateClaim($id: UUID!, $claimId: UUID!, $claim: TicketClaimInput!) {
    order(id: $id) {
      updateClaim(claimId: $claimId, claim: $claim) {
        errors
        claim {
          ...TicketClaimFragment
        }
      }
    }
  }
  ${TICKET_CLAIM_FRAGMENT}
`;

export const UPDATE_ALL_CLAIMS = gql`
  mutation UpdateAllClaims($id: UUID!, $claim: TicketClaimInput!) {
    order(id: $id) {
      updateAllClaims(claim: $claim) {
        errors
        order {
          ...OrderFragment
        }
      }
    }
  }
  ${ORDER_FRAGMENT}
`;

export const RELEASE_CLAIMS = gql`
  mutation ReleaseClaims($id: UUID!, $claimIds: [UUID]!) {
    order(id: $id) {
      releaseClaims(claimIds: $claimIds) {
        errors
        order {
          ...OrderFragment
        }
      }
    }
  }
  ${ORDER_FRAGMENT}
`;

export const COMPLETE_ORDER = gql`
  mutation CompleteOrder($id: UUID!, $token: String, $paymentMethodId: UUID) {
    order(id: $id) {
      complete(paymentToken: $token, paymentMethodId: $paymentMethodId) {
        errors
        preview
      }
    }
  }
`;

export const APPLY_PROMO_CODE = gql`
  mutation ApplyPromoCode($id: UUID!, $code: String!) {
    order(id: $id) {
      applyPromoCode(code: $code) {
        messages { ...MessageFragment }
        errors
        order {
          ...OrderFragment
        }
      }
    }
  }
  ${MESSAGE_FRAGMENT}
  ${ORDER_FRAGMENT}
`;

export const UPDATE_ORDER = gql`
  mutation UpdateOrder($id: UUID!, $order: UpdateOrderInput!) {
    order(id: $id) {
      update(order: $order) {
        errors
        order {
          ...OrderFragment
        }
      }
    }
  }
  ${ORDER_FRAGMENT}
`;
